import script from "./SkipLink.vue?vue&type=script&setup=true&lang=js"
export * from "./SkipLink.vue?vue&type=script&setup=true&lang=js"

import "./SkipLink.vue?vue&type=style&index=0&id=2a6cea8d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6cea8d"]])

export default __exports__